import { Div } from "../Div";

declare const google: any;

export class GMap extends Div {
    protected createSelf() {
        super.createSelf();
        const map = new google.maps.Map(this.getElement(), {
            center: this.get("center"),
            zoom: this.get("zoom"),
        });
        new google.maps.Marker({
            position: this.get("center"),
            map,
        });
    }
}
